import { Component } from '@angular/core';

@Component({
  selector: 'app-wgc-page-not-found',
  template: `<p>  This page does not exist  <a href='/catalogs'>go to Catalog home</a></p>`,
  standalone: false
})
export class PageNotFoundComponent{}
